import React from 'react';
import { Button, useRecordContext } from 'react-admin';
import Queue from '@mui/icons-material/Queue';
import { useNavigate } from 'react-router-dom';
import { stringify } from 'query-string';

const defaultIcon = <Queue />;

const omitFieldsFunc = function({ id, Order_Date, Order_Num, PickUp_Date, Delivery_Date, PO_Num, Billing_Notes, Qty_Loaded, Confirmed, ...rest }) {
    let clone = Object.assign({}, rest);
    if ('OrderDetails' in clone) {
        clone['OrderDetails'] = clone['OrderDetails'].map(({id, OrderID, Release_Num, Qty_Loaded, Confirmed, ...rest2}) => rest2);
    }
    return clone;
};

const OrderCloneButton = ({
    icon = defaultIcon,
    label = 'Clone',
    ...rest
}) => {
    const record = useRecordContext();
    const navigate = useNavigate();

    const handleClick = (event) => {
        // Prevent row expansion when clicking clone button
        event.stopPropagation();

        if (record) {
            const clonedData = omitFieldsFunc(record);
            navigate({
                pathname: '/orders/create',
                search: stringify({
                    source: JSON.stringify(clonedData),
                }),
            });
        }
    };

    return (
        <Button
            onClick={handleClick}
            label={label}
            {...rest}
        >
            {icon}
        </Button>
    );
};

export default OrderCloneButton;
